import styled from '@emotion/styled';
import {
  Row,
  Column,
  Divider,
  device,
  Reveal,
  shouldForwardProp,
} from '@landsbankinn/ui';
import React from 'react';
import type { ImgSource } from '../../components/img/Img';
import { Img } from '../../components/img/Img';

interface IProps {
  title?: React.ReactNode;
  copy?: React.ReactNode;
  image: ImgSource;
  isGray: boolean;
  mergeTop?: boolean;
}

const Host = styled(Reveal, {
  shouldForwardProp: shouldForwardProp('div'),
})<{ isGray: boolean; mergeTop?: boolean }>`
  padding: ${(props) =>
    props.mergeTop
      ? `${props.theme.breakpoints.sm.gutter}px ${props.theme.breakpoints.sm.gutter}px`
      : `${props.theme.breakpoints.sm.gutter * 2}px ${
          props.theme.breakpoints.sm.gutter
        }px`};
  background: ${(props) =>
    props.isGray ? props.theme.colors.backgroundAlt : 'transparent'};

  @media ${device.tablet} {
    padding: ${(props) =>
      props.mergeTop
        ? `${props.theme.breakpoints.md.gutter}px 0`
        : `${props.theme.breakpoints.md.gutter * 2}px 0`};
  }

  @media ${device.desktop} {
    padding: ${(props) =>
      props.mergeTop
        ? `${props.theme.breakpoints.lg.gutter}px 0`
        : `${props.theme.breakpoints.lg.gutter * 2}px 0`};
  }
`;

const ImageWrap = styled.div``;

const Title = styled.div``;

const Copy = styled.div`
  margin-bottom: 60px;

  @media ${device.tablet} {
    margin-bottom: 0;
  }
`;

export const TextWithIcon = ({
  title,
  copy,
  image,
  isGray,
  mergeTop,
}: IProps) => {
  return (
    <Host isGray={isGray} mergeTop={mergeTop}>
      <Row>
        <Column
          md={{
            width: 6 / 12,
            offset: 1 / 12,
          }}
        >
          <Copy>
            {!!title && <Title>{title}</Title>}
            {!!title && <Divider margin="40px 0" />}
            {copy}
          </Copy>
        </Column>

        <Column
          md={{
            width: 3 / 12,
            offset: 1 / 12,
          }}
        >
          <ImageWrap>
            <Img src={image} ar="ar_1_1" percentage={3 / 12} />
          </ImageWrap>
        </Column>
      </Row>
    </Host>
  );
};
